'use strict';

const Event = require('../lib/events');
const Breakpoint = require('../lib/breakpoints');

class equalHeights {

    constructor() {

        Event.on('load resize', window, () => {

            this.equalRow = document.querySelectorAll('[data-rk-equalizer]');

            //  Check if equalizer is on this page
            if (this.equalRow.length > 0) {

                for (let set of this.equalRow) {

                    let watcher = set.getAttribute('data-rk-equalizer') || '';
                    let multiWatcher = watcher.split(',');
                    let onBreakpoint = set.getAttribute('data-rk-equalizer-on') || 'small';
                    let equalizerByRow = set.getAttribute('data-rk-equalizer-by-row') || false;

                    for (let i = 0; i < multiWatcher.length; i++) {

                        let items = set.querySelectorAll(`[data-rk-equalizer-watch="${multiWatcher[i]}"]`);

                        if (items.length > 1) {

                            if (equalizerByRow) {

                                let rows = this.divideItemsByRow(items);

                                for (let row of rows) {

                                    this.setHeights(row, onBreakpoint);
                                }
                            } else {

                                this.setHeights(items, onBreakpoint);
                            }
                        }
                    }
                }
            }
        });
    }

    /**
     * Calculate the tallest element of the items and return it's height
     * @param items
     * @return {*}
     */
    calculateTallest(items) {

        return Math.max.apply(Math, [].slice.call(items).map((element) => {
            element.style.height = '';

            return element.offsetHeight;
        }));
    }

    /**
     * Set the height on all matching items
     * @param items
     * @param height
     */
    setItemHeight(items, height) {

        for (let i = 0; i < items.length; i++) {

            items[i].style.height = (height === 'auto' ? 'auto' : `${height}px`);
        }
    }

    /**
     * Divide items by the amount of rows they form, this is done by checking the matching top offsets
     * @param items
     * @return {Array}
     */
    divideItemsByRow(items) {

        let lastElementOffsetTop = (items.length > 0 ? items[0].offsetTop : 0);
        let rows = [];
        let rowIndex = 0;

        rows[rowIndex] = [];

        if (items.length > 0) {

            for (let i = 0; i < items.length; i++) {

                let item = items[i];
                let itemRects = item.getClientRects();

                let elementOffsetTop = itemRects[0].top;

                if (elementOffsetTop !== lastElementOffsetTop) {

                    rowIndex++;
                    rows[rowIndex] = [];
                    lastElementOffsetTop = elementOffsetTop;
                }

                rows[rowIndex].push(items[i]);
            }
        }

        return rows;
    }

    /**
     *
     * @param items
     * @param onBreakpoint
     */
    setHeights(items, onBreakpoint) {

        if (Breakpoint.atLeast(onBreakpoint)) {

            let height = this.calculateTallest(items);
            this.setItemHeight(items, height);

            //  CUSTOM HOOK for WBT
            this.setItemMargin(items, height);
        } else {

            this.setItemHeight(items, 'auto');

            //  CUSTOM HOOK for WBT
            this.setItemMargin(items, 'auto');
        }
    }

    /**
     * CUSTOM HOOK for WBT
     * Checks if current matched item in equalizer-watch mode also has [data-rk-equalizer-add-margin-to="*"]
     * "*" is the matching watcher for this to apply the height of current match as the margin-bottom
     * @param items
     * @param marginBottom
     */
    setItemMargin(items, marginBottom) {

        for (let i = 0; i < items.length; i++) {

            let item = items[i];

            if (item.dataset.rkEqualizerAddMarginTo) {

                let targetItem = item.parentNode.querySelector(`[data-rk-equalizer-watch="${item.dataset.rkEqualizerAddMarginTo}"]`);

                if (targetItem) {

                    targetItem.style.marginBottom = (marginBottom === 'auto' ? `0px` : `${marginBottom}px`);
                }
            }
        }
    }
}

module.exports = equalHeights;
